import { createFileRoute, Outlet } from '@tanstack/react-router'
import { Main, PageWrapper } from '~/components/elements'
import { Header } from '~/components/header'
import { Sidebar } from '~/components/sidebar'

export const Route = createFileRoute('/_authenticated')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <Main>
      <Sidebar />
      <PageWrapper>
        <Header />
        <Outlet />
      </PageWrapper>
    </Main>
  )
}
